/*
 * @Author: yuxiaojing
 * @Date: 2018-02-22 14:11:59
 * @Last Modified by: yuxiaojing
 * @Last Modified time: 2018-02-22 14:50:50
 */

import axios from './axios'
import constant from './constant' /* 正则 */
import * as myFilter from './filter' /* 过滤器 */
import {
  Navbar, Tabbar, TabItem, TabContainer, TabContainerItem, Popup, Spinner, Picker,
  Toast, MessageBox, InfiniteScroll, Loadmore, Field, Radio, Checklist
} from 'mint-ui'
// import { Switch, CellGroup, SwitchCell, Search } from 'vant'

// import MintUI from 'mint-ui'
// 兼容IOS设置页面title
function setTitle (title) {
  document.title = title
  let ua = navigator.userAgent
  if (/\bMicroMessenger\/([\d.]+)/.test(ua) && /ip(hone|od|ad)/i.test(ua)) {
    let i = document.createElement('iframe')
    i.src = ''
    i.style.display = 'none'
    i.onload = function () {
      setTimeout(function () {
        i.remove()
      }, 9)
    }
    document.body.appendChild(i)
  }
}

export default {
  install: (Vue) => {
    // vantUI引入组件
    // Vue.use(Switch)
    // Vue.use(SwitchCell)
    // Vue.use(CellGroup)
    // Vue.use(Search)
    // Vue.component(Button.name, Button)
    // Vue.use(MintUI) // 引入mint-ui全部组件
    Vue.component(Tabbar.name, Tabbar)
    Vue.component(Navbar.name, Navbar)
    Vue.component(TabItem.name, TabItem)
    Vue.component(TabContainer.name, TabContainer)
    Vue.component(TabContainerItem.name, TabContainerItem)
    Vue.component(Popup.name, Popup)
    Vue.component(Spinner.name, Spinner)
    Vue.component(Picker.name, Picker)
    Vue.component(Loadmore.name, Loadmore)
    Vue.component(Field.name, Field)
    Vue.component(Radio.name, Radio)
    Vue.component(Checklist.name, Checklist)
    Vue.use(InfiniteScroll)
    Vue.prototype.Toast = Toast
    Vue.prototype.MessageBox = MessageBox

    // 绑定到vue实例的原型链上，这样可以在组件中直接调用this.$axios.get()，而不需要用inport引入axios模块
    Vue.prototype.$axios = axios
    Vue.prototype.setTitle = setTitle // 在组件内直接调用 this.setTitle('title')
    Vue.prototype.constant = constant
    Object.keys(myFilter).forEach(key => {
      Vue.filter(key, myFilter[key])
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js